module.exports = __webpack_public_path__ + "img/b.7d91ef30.png";